var map = {
	"./icon-admin.svg": "501d",
	"./icon-bianji.svg": "ac9b",
	"./icon-config.svg": "da78",
	"./icon-dangdifill.svg": "b0c4",
	"./icon-daohang.svg": "ef88",
	"./icon-duanxin.svg": "c7d8",
	"./icon-editor.svg": "c4cd",
	"./icon-form.svg": "8e0e",
	"./icon-geren.svg": "64e4",
	"./icon-jiesuo.svg": "f587",
	"./icon-job.svg": "b688",
	"./icon-log.svg": "e181",
	"./icon-menu.svg": "444b",
	"./icon-mudedi.svg": "8eb2",
	"./icon-order.svg": "5989",
	"./icon-oss.svg": "184a",
	"./icon-pinglun.svg": "bc2e",
	"./icon-prod.svg": "62be",
	"./icon-role.svg": "e9cb",
	"./icon-shanchu.svg": "3641",
	"./icon-shezhi.svg": "f626",
	"./icon-shoucang.svg": "4049",
	"./icon-shoucangfill.svg": "aea9",
	"./icon-shouye.svg": "edb3",
	"./icon-sousuo.svg": "116b",
	"./icon-sql.svg": "a1fb",
	"./icon-store.svg": "bbdc",
	"./icon-suoding.svg": "0e50",
	"./icon-system.svg": "524a",
	"./icon-tixing.svg": "0804",
	"./icon-tubiao.svg": "6f42",
	"./icon-vip.svg": "5a03",
	"./icon-xiangqu.svg": "7752",
	"./icon-xiangqufill.svg": "7fd7",
	"./icon-zhedie.svg": "e789",
	"./icon-zonghe.svg": "76d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e81";